import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

const TransactionTable = ({ title, transactions }) => {
  const sumAmount = transactions ? transactions.reduce((acc, transaction) => acc + transaction.amount, 0) : 0;

  return (
    <div>
      <p className="text-start fw-bold">{title}</p>
      <table className="table table-striped table-hover mb-5">
        <thead>
          <tr>
            <th scope="col">No</th>
            <th scope="col">Value Date</th>
            <th scope="col">Tran. Type</th>
            <th scope="col">Tran. Number</th>
            <th scope="col">Account</th>
            <th scope="col">Amount</th>
            <th scope="col">Memo</th>
            <th scope="col">User</th>
          </tr>
        </thead>
        <tbody>
          {transactions && transactions.map((transaction, index) => (
            <tr key={index}>
              <td>{transaction.id}</td>
              <td>{new Date(transaction.valueDate).toLocaleString()}</td>
              <td>{transaction.transactionType}</td>
              <td>{transaction.transactionNumber}</td>
              <td>{transaction.accountNumber}</td>
              <td>{transaction.amount}</td>
              <td>{transaction.memo}</td>
              <td>{transaction.user}</td>
            </tr>
          ))}
          <tr>
            <td colSpan="5"></td>
            <td className="fw-bold">Total:</td>
            <td className="fw-bold">{sumAmount.toLocaleString()}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

function DailyTransactions() {
  const [data, setData] = useState({});
  const [date, setDate] = useState(null);

  const location = useLocation();

  useEffect(() => {
    console.log("Location State:", location.state);
    if (location.state) {
      setData(location.state);
      // setDate(location.state.valueDate);
      const date = new Date(location.state.selectedDate);
      setDate(date.toLocaleDateString('en-US')); // assuming location.state.valueDate contains the selected date
    } else {
      console.log('No data in location.state');
    }
  }, [location]);

  return (
    <div className="container">
      <div className="row">
        <div className="col mb-5">
          <h3 className="text-center my-4">Daily Transactions Report - {date}</h3>
        </div>
      </div>

      <div className="row">
        {data.CD && data.CD.length > 0 && (
          <>
            <h5 className="text-center">Cash - Deposit Account</h5>
            <TransactionTable title="Cash Deposit" transactions={data.CD} />
          </>
        )}
        {data.CW && data.CW.length > 0 && (
          <TransactionTable title="Cash Withdraw" transactions={data.CW} />
        )}
        {data.LP && data.LP.length > 0 && (
          <TransactionTable title="Loan Payment" transactions={data.LP} />
        )}
        {data.PD && data.PD.length > 0 && (
          <TransactionTable title="Promotion Deposit" transactions={data.PD} />
        )}
        {data.ACD && data.ACD.length > 0 && (
          <TransactionTable title="ATM Cash Deposit" transactions={data.ACD} />
        )}
        {data.ACW && data.ACW.length > 0 && (
          <TransactionTable title="ATM Cash Withdraw" transactions={data.ACW} />
        )}
        {(data.voucherDebit && data.voucherDebit.length > 0) || (data.voucherCredit && data.voucherCredit.length > 0) ? (
          <div className="row">
            <h5 className="text-center">Cash - Ledger Account</h5>
            {data.voucherDebit && data.voucherDebit.length > 0 && (
              <TransactionTable title="Cash Vouchers Debit" transactions={data.voucherDebit} />
            )}
            {data.voucherCredit && data.voucherCredit.length > 0 && (
              <TransactionTable title="Cash Vouchers Credit" transactions={data.voucherCredit} />
            )}
          </div>
        ) : null}
        {data.nonCashDepositList && data.nonCashDepositList.length > 0 && (
          <TransactionTable title="Non Cash Deposit" transactions={data.nonCashDepositList} />
        )}
        {data.nonCashWithdrawList && data.nonCashWithdrawList.length > 0 && (
          <TransactionTable title="Non Cash Withdraw" transactions={data.nonCashWithdrawList} />
        )}
        {data.nonCashLedgerList && data.nonCashLedgerList.length > 0 && (
          <TransactionTable title="Non Cash Ledger" transactions={data.nonCashLedgerList} />
        )}
      </div>
    </div>
  );
}

export default DailyTransactions;
